export class SellerAdjustmentTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes({ includeDeleted } = {}) {
    return this.#http.get('/api/seller-adjustment-types', { params: { includeDeleted } });
  }

  async createType(body) {
    return this.#http.post('/api/seller-adjustment-types', body);
  }

  async editType({ sellerAdjustmentTypeId, ...body }) {
    return this.#http.put(`/api/seller-adjustment-types/${sellerAdjustmentTypeId}`, body);
  }

  async deleteType({ sellerAdjustmentTypeId }) {
    return this.#http.delete(`/api/seller-adjustment-types/${sellerAdjustmentTypeId}`);
  }
}
